function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWave7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fc96ff79-82c8-42af-95a4-2d773f9de3ab",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 48"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "e0893572-e819-49ff-ac0a-1124fdf7477d",
    "data-name": "Wave-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f6e2e282-2e3d-4f5b-b248-e293c1b5dbd2",
    "data-name": "Rectangle-Copy-6",
    d: "M0,48H1366v-.77527C1240.48938,48.50505,669.439,0,299,0H0Z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  })));
}

export default SvgWave7;